export interface NotificationSettings {
  soundEnabled: boolean;
  visualEnabled: boolean;
  sections: {
    tickets: boolean;
    feedback: boolean;
    orders: boolean;
    entertainment: boolean;
  };
}

export interface NotificationCounts {
  new_tickets_count: number;
  new_orders_count: number;
  new_feedbacks_count: number;
  new_book_count: number;
}

export const DEFAULT_NOTIFICATION_SETTINGS: NotificationSettings = {
  soundEnabled: true,
  visualEnabled: true,
  sections: {
    tickets: true,
    feedback: true,
    orders: true,
    entertainment: true,
  },
};
